import { FormControlLabel } from '@mui/material';
import CheckboxRoot from '@mui/material/Checkbox';
import { ICheckbox } from './types';

const Checkbox = ({
  onChange = () => {},
  checked = false,
  label = '',
  labelPlacement = 'end',
  ...props
}: ICheckbox) => {
  return (
    <FormControlLabel
      sx={{ m: 0 }}
      label={label}
      control={<CheckboxRoot checked={checked} onChange={onChange} />}
      labelPlacement={labelPlacement}
      {...props}
    />
  );
};

export default Checkbox;
